export default __webpack_public_path__ + "static/media/a2-4-16.c03cca29.jpg";